export default "__VITE_ASSET__Donar_Pv__"